import React from 'react';

const RightButton = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" fill="white" />
    <g clipPath="url(#clip0_623_8887)">
      <path
        d="M12.6666 22C12.744 22.0776 12.836 22.1392 12.9372 22.1812C13.0385 22.2232 13.147 22.2448 13.2566 22.2448C13.3662 22.2448 13.4748 22.2232 13.576 22.1812C13.6772 22.1392 13.7692 22.0776 13.8466 22L19.3866 16.46C19.5108 16.3351 19.5805 16.1661 19.5805 15.99C19.5805 15.8139 19.5108 15.6449 19.3866 15.52L13.8466 9.99999C13.6883 9.85761 13.4814 9.78125 13.2685 9.78659C13.0556 9.79194 12.8529 9.87859 12.7018 10.0287C12.5508 10.1789 12.463 10.3812 12.4565 10.594C12.4499 10.8069 12.5251 11.0142 12.6666 11.1733L17.4933 16L12.6666 20.84C12.5159 20.9955 12.4316 21.2035 12.4316 21.42C12.4316 21.6365 12.5159 21.8445 12.6666 22Z"
        fill="#6B6C7B"
      />
    </g>
    <rect x="0.5" y="0.5" width="31" height="31" rx="3.5" stroke="#D5D5D9" />
    <defs>
      <clipPath id="clip0_623_8887">
        <rect width="16" height="16" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);

export default RightButton;
